import { Collapse } from 'antd'
import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

const { Panel } = Collapse

const Wrapper = styled.div`
	.ant-collapse {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		color: rgba(0, 0, 0, 0.88);
		font-size: 14px;
		line-height: 1.5714285714285714;
		list-style: none;
		background-color: rgba(0, 0, 0, 0.02);
		border: none;
		border-top: solid 1px #00bfc8;
		border-radius: 0;

		.ant-collapse-item {
			border-bottom: 1px solid #00bfc8;
			box-sizing: border-box;
			border-radius: 0;

			&.ant-collapse-item-active {
				.anticon {
					transform: rotate(-180deg);
				}
			}

			.ant-collapse-header {
				background-color: ${themeGet('background.2', '#F0FAFC')};
			}

			.ant-collapse-content {
				&.ant-collapse-content-hidden {
					display: none;
				}

				.ant-collapse-content-box {
					background: #f5f8fb;
				}
			}
		}
	}

	.ant-collapse-header {
		position: relative;
		display: flex;
		flex-wrap: nowrap;
		align-items: flex-start;
		padding: 12px 16px;
		color: rgba(0, 0, 0, 0.88);
		line-height: 1.5714285714285714;
		cursor: pointer;
		transition: all 0.3s, visibility 0s;

		&.ant-collapse-header-collapsible-only {
			padding: 12px 28px;
			background-color: rgba(0, 191, 200, 0.05);

			.ant-collapse-expand-icon {
				padding-inline-end: 16px;
			}

			@media (max-width: 1200px) {
				padding: 12px 16px;
			}
			@media (max-width: 768px) {
				padding: 8px 12px;

				.ant-collapse-expand-icon {
					padding-inline-end: 8px;
				}
			}
		}

		.ant-collapse-expand-icon {
			.anticon {
				position: relative;
				width: 24px;
				height: 24px;
				transition: transform 0.2s;

				&:before {
					display: block;
					content: '';
					position: absolute;
					top: 50%;
					left: 50%;
					width: 100%;
					height: 100%;
					background: url('/static/assets/icon_folding.svg') no-repeat 50% 50%;
					background-size: contain;
					transform: translate(-50%, -50%);
				}

				svg {
					display: none;
				}
			}

			@media (max-width: 1200px) {
			}
			@media (max-width: 768px) {
				.anticon {
					width: 16px;
					height: 16px;
				}
			}
		}

		.ant-collapse-header-text {
			font-size: 16px;
			font-weight: bold;
			line-height: 1.5;
			color: ${themeGet('text.0', '#1B1B29')};

			@media (max-width: 1200px) {
			}
			@media (max-width: 768px) {
				font-size: 14px;
			}
		}
	}

	.ant-collapse-content {
		background-color: #ffffff;
		border-top: 1px solid #00bfc8;

		.ant-collapse-content-box {
			padding: 25px 40px 32px 64px;

			p {
				font-size: 15px;
				line-height: 1.5;
				color: ${themeGet('text.0', '#1B1B29')};
				margin: 0;
			}

			@media (max-width: 1200px) {
				padding: 25px 40px 32px 56px;
			}
			@media (max-width: 768px) {
				padding: 16px 24px 16px 36px;

				p {
					font-size: 14px;
				}
			}
		}
	}
`

export type FaqType = {
	id: number
	title: string
	content: ReactNode
}

export const IntroFaqs: React.FC<{ faqs: FaqType[] }> = ({ faqs }) => {
	return (
		<Wrapper>
			<Collapse collapsible="header" defaultActiveKey={['1']}>
				{faqs &&
					faqs.map((faq) => (
						<Panel header={faq.title} key={faq.id}>
							<div>{faq.content}</div>
						</Panel>
					))}
			</Collapse>
		</Wrapper>
	)
}
